/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EquipmentBrowserViewMeta,
  EquipmentBrowserViewMeta$inboundSchema,
} from "./equipmentbrowserviewmeta.js";

/**
 * The equipment browser configuration.
 */
export type EquipmentBrowserConfig = {
  /**
   * Universally unique identifier
   */
  defaultView: string;
  /**
   * The ordering of views for the user requesting the configuration.
   */
  viewOrder: Array<string>;
  /**
   * The equipment browser config options
   */
  views: Array<EquipmentBrowserViewMeta>;
};

/** @internal */
export const EquipmentBrowserConfig$inboundSchema: z.ZodType<
  EquipmentBrowserConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  default_view: types.string(),
  view_order: z.array(types.string()),
  views: z.array(EquipmentBrowserViewMeta$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "default_view": "defaultView",
    "view_order": "viewOrder",
  });
});

export function equipmentBrowserConfigFromJSON(
  jsonString: string,
): SafeParseResult<EquipmentBrowserConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EquipmentBrowserConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EquipmentBrowserConfig' from JSON`,
  );
}
